import { memo, useMemo } from 'react';

import Typography from 'components/UI/Typography/Typography';

import { RULES } from 'components/config/rewardSystem';

import styles from './BonusOpportunity.module.scss';

const BonusOpportunity = () => {
  const itemsJSX = useMemo(
    () =>
      RULES.bonusOpportunity.map(({ title, description, icon }) => (
        <div key={title} className={styles.item}>
          <div className={styles.titleWrapper}>
            <div className={styles.iconWrapper}>
              <div className={styles.icon}>{icon}</div>
            </div>
            <Typography weight="semibold">{title}</Typography>
          </div>
          <Typography color="grey">{description}</Typography>
        </div>
      )),
    [],
  );

  return (
    <div className={styles.root}>
      <Typography type="text-lg" weight="medium" uppercase>
        Bonus Opportunity: Seasonal Growth Challenge
      </Typography>
      <div className={styles.items}>{itemsJSX}</div>
    </div>
  );
};

export default memo(BonusOpportunity);
